<i18n src="../../locales/lang.json"></i18n>

<template>
  <div style="display:inline;color:inherit">
    <button type="button" class="btn btn-icon rounded-pill" @click.stop="show" style="color:inherit"><i class="icon-help icon-2x"></i></button>
    <div id="nux-overlay" class="nux-overlay-item"></div>
  </div>
</template>

<script>
	export default {
    name: 'help-icon',
		components: {
    },
    props: {
      id: {
        required: false,
        type: String,
        default:null
      },
    },
    data() {
      return {
        
      };
    },
    methods: {
      getId() {
        if (this.id == null || typeof (this.id) == "undefined") {
          this.id = 'image_' + this._uid;
          return 'image_' + this._uid;
        }
        return this.id;
      },
      show() {
        $(".nux-overlay-item").show();
        this.$root.$emit('help', 1);
      },
      documentClosehelp() {
        this.$root.$emit("endhelp");
      },
      hide() {
        $(".nux-overlay-item").hide();
      },
    },
    created() {
      
    },
    mounted() {

      var thisContext = this;

      this.$root.$on('endhelp', function () { thisContext.hide() });

      jQuery("body").on('click', function () { thisContext.documentClosehelp() });
    }

}
</script>

<style scoped>

  #nux-overlay {
    position: fixed; /* Sit on top of the page content */
    display: none; /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
</style>



// WEBPACK FOOTER //
// src/components/general/help-icon.vue